import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "15",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#D3EFEC",
      "fill-rule": "evenodd",
      d: "M2.627 2.24a5.6 5.6 0 1 1 7.92 7.92l-3.96 3.96-3.96-3.96a5.6 5.6 0 0 1 0-7.92m3.96 5.56a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }